module.exports = __webpack_public_path__ + "static/media/icon_button2_a.d4fc02a2.svg";